import actionCreatorFactory from 'typescript-fsa';

import { ICareerInfo } from '../actions/search';

const actionCreator = actionCreatorFactory();

/** 実施期間情報 */
export interface ISkillPeriod {
	periodId: string; // 実施期間ID
	periodName?: string; // 実施期間名
	periodStartDate?: Date; // 実施期間開始日
	periodEndDate?: Date; // 実施期間終了日
	cost?: string; // 費用
	selfCost?: string; // 自己分担額
	applStartDate?: Date; // 申込期間開始日
	applEndDate?: Date; // 申込期間終了日
	periodDate?: string; // 実施期間
	applDate?: string; // 申込期間
}

/** スキル関連資料 */
export interface IMaterialFile {
	fileName?: string; // 資料ファイル名
	fileType?: string; // 資料ファイル種類
	fileIndex: number; // ファイルのIndex
}

/** スキル詳細情報 */
export interface ISkillDetail {
	skillId: string; // スキルID
	skillName?: string; // スキル名
	managementCode?: string; // 管理番号
	type?: string; // 種別
	subType?: string; // サブ種別
	compulsoryID?: string; // 区分
	ranksFlag?: string; // ランク利用区分
	scoreRegisterFlag?: string; // 得点登録利用区分
	scoreItemsRegisterFlag?: string; // 得点内訳登録利用区分
	target?: string; // 対象者
	skillManager?: string; // スキル管理者
	purpose?: string; // 目的
	outline?: string; // 概要
	credit?: number; // 単位
	vendor?: string; // ベンダ名
	vendorURL?: string; // ベンダURL
	inquiry?: string; // 問い合わせ先
	applicationFlg?: string; // 申込方法
	reference?: string; // 申込み先
	referenceURL?: string; // 申込み先URL
	comment?: string; // 備考
	periodInfoList?: ISkillPeriod[]; // 実施期間情報一覧リスト
	necessaryCareerList?: ICareerInfo[]; // スキル認定必要な研修一覧リスト
	materialFileList?: IMaterialFile[]; // スキル関連資料リスト
}

/**
 * スキル詳細情報画面設定アクションクリエータ
 */
export const setSkillDetail = actionCreator<{
	skillInfo: ISkillDetail;
}>('SET_SKILL_DETAIL');



// WEBPACK FOOTER //
// ./src/actions/skillDetail.ts